import React, { useState, useRef, useEffect } from "react";
import Sketch from "@uiw/react-color-sketch";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeDropper } from "@fortawesome/free-solid-svg-icons";

function getContrastColor(hex) {
  // buang tanda #
  const c = hex.replace("#", "")
  const r = parseInt(c.substring(0, 2), 16)
  const g = parseInt(c.substring(2, 4), 16)
  const b = parseInt(c.substring(4, 6), 16)

  // rumus luminance (perceived brightness)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  return luminance > 0.5 ? "#000000" : "#ffffff" // terang → hitam, gelap → putih
}

export default function ColorInput({ value, onChange }) {
  const [show, setShow] = useState(false);
  const [hex, setHex] = useState(value || "#FFFFFF");
  const ref = useRef(null);
  const iconColor = getContrastColor(hex)
  useEffect(() => {
    if (value) {
      setHex(value.toUpperCase());
    }
  }, [value]);
  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (color) => {
    setHex(color.hex.toUpperCase());
    setShow(!show)
    onChange && onChange(color.hex.toUpperCase());
  };

  return (
    <div className="position-relative d-inline-block" ref={ref}>
      {/* Input seperti datepicker */}
      <Button variant="ghost" className="cursor-pointer hover:opacity-80" style={{backgroundColor:hex}} onClick={()=>setShow(!show)}>
        <FontAwesomeIcon icon={faEyeDropper} color={iconColor}></FontAwesomeIcon>
      </Button>

      {/* Popover color picker */}
      {show && (
        <div
          className="position-absolute mt-1 p-2 bg-white rounded shadow border"
          style={{ zIndex: 1050 }} // biar di atas modal/dropdown
        >
          <Sketch color={hex} onChange={handleChange} />
        </div>
      )}
    </div>
  );
}
